<ion-icon
  [src]="iconSrc"
  [style.width.px]="getIconSize()"
  [style.height.px]="getIconSize()"
/>
